import axios from 'axios';
import { setRefreshHeadersToken } from './helpers';

const apiV2Instance = axios.create({
  baseURL: process.env.REACT_APP_API_V2,
  // baseURL:
  //   'https://5c0e-45-174-238-113.ngrok-free.app/growyxdev/us-central1/httpFunctions-gapiV2/',
  headers: {
    Accept: 'application/json',
    // 'ngrok-skip-browser-warning': 'true',
  },
});

apiV2Instance.interceptors.request.use(config =>
  setRefreshHeadersToken(config, apiV2Instance),
);

apiV2Instance.interceptors.response.use(value => {
  const workspaceId = value?.headers?.workspaceid;

  if (workspaceId) {
    sessionStorage.setItem('RESPONSE_HEADER_WORKSPACE_ID', workspaceId);
  }

  return value;
});

export { apiV2Instance };
